module.exports = __webpack_public_path__ + "static/media/order_icon32.810d1249.png";